import config from 'config/config';
import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export interface NotificationSettingsData {
    pushEnabled: boolean;
    meetingReminder: boolean;
    chatNotification: boolean;
    scheduleNotification: boolean;
    costNotification: boolean;
}

export class NotificationRepository {
    /**
     * DOKOCREW 알림 설정 조회
     */
    static onGetSettings = () => {
        return onRequest({
            url: getApiUrl('notificationSettings'),
            method: RequestMethod.GET,
        })
    }

    /**
     * DOKOCREW 알림 설정 저장 (세부 항목: 모임/채팅/일정/정산)
     */
    static onSaveSettings = (params: NotificationSettingsData) => {
        return onRequest({
            url: getApiUrl('notificationSettings'),
            method: RequestMethod.PUT,
            params,
        })
    }

    /**
     * WIZ-SSO 전체 푸시 동의 조회 (tb_user_msg_consent)
     */
    static onGetPushConsent = () => {
        return onRequest({
            url: getApiUrl('ssoPushConsent'),
            method: RequestMethod.GET,
        })
    }

    /**
     * WIZ-SSO 전체 푸시 동의 변경
     */
    static onUpdatePushConsent = (pushEnabled: boolean) => {
        return onRequest({
            url: getApiUrl('ssoPushConsent'),
            method: RequestMethod.PUT,
            params: {
                pushConsent: pushEnabled,
                serviceId: config.SERVICE_ID,
            },
        })
    }

    /**
     * WIZ-MESSAGE 푸시 발송
     * @param params.userNos - 수신 대상 사용자 번호 배열
     * @param params.title - 푸시 제목
     * @param params.body - 푸시 내용
     * @param params.data - 추가 데이터 (딥링크 등)
     */
    static onSendPush = (params: {
        userNos: number[];
        title: string;
        body: string;
        data?: Record<string, string>;
    }) => {
        return onRequest({
            url: getApiUrl('wizMessagePush'),
            method: RequestMethod.POST,
            params: {
                serviceId: config.SERVICE_ID,
                targetUserNos: params.userNos,
                title: params.title,
                body: params.body,
                data: params.data || {},
            },
        })
    }

    /**
     * WIZ-MESSAGE 내 푸시 이력 조회 (홈 알림 카드용)
     * — 최근 모임 관련 알림만 필터링해서 상단 카드로 보여주는 용도
     */
    static onGetPushHistory = (params: { userNo: number; pageSize?: number }) => {
        return onRequest({
            url: getApiUrl('wizMessagePushHist'),
            method: RequestMethod.POST,
            params: {
                serviceId: config.SERVICE_ID,
                userNo: params.userNo,
                pageNo: 1,
                pageSize: params.pageSize ?? 20,
            },
        })
    }
}
